/**
 * A helper to remove comma "," from a value.
 * @param {string} value a string value
 * @returns {string} return the plane value without comma
 */
export const removeCommaFromValue = (value: string) => {
  return value.replaceAll(',', '');
};
